<template>
  <v-container fluid>
    <PageHeader :title="name" no-padding />

    <PageLoader class="my-5" resourceName="guideline" v-if="!loadingHasFinish" />
    <template v-else-if="currentGuideline">
      <TenantGuidelinesDetailForm class="mb-3" :currentGuideline="currentGuideline" :name="name" :isAddpageForm="false" :isTenantEditable="isTenantEditable" v-if="isTenantAdmin" />
      <TenantGuidelinesDetailStandards :currentGuideline="currentGuideline" :name="name" :isAddpageForm="false" :isTenantEditable="isTenantEditable" v-if="isTenantAdmin" />
    </template>
    <v-card v-else>
      <v-card-title>
        <v-icon color="warning" class="mr-2">warning</v-icon>
        Guideline was not found.
      </v-card-title>
    </v-card>
  </v-container>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import TenantGuidelinesDetailForm from './TenantGuidelinesDetailForm'
  import TenantGuidelinesDetailStandards from './TenantGuidelinesDetailStandards'
  import PageHeader from '@/components/generic/PageHeader'
  import { AddGuidelineActionName } from '@/components/mixins/GuidelinesManageUtil'
  import PageLoader from '@/components/generic/PageLoader'

  const stations = createNamespacedHelpers('stations')
  const guidelines = createNamespacedHelpers('guidelines')
  const admin = createNamespacedHelpers('admin')
  const authenticate = createNamespacedHelpers('authenticate')
  const app = createNamespacedHelpers('app')

  export default {
    components: {
      PageHeader,
      PageLoader,
      TenantGuidelinesDetailForm,
      TenantGuidelinesDetailStandards,
    },
    props: {
      name: {
        type: String,
        default: null,
      },
    },
    computed: {
      ...stations.mapGetters(['mediaTypeList']),
      ...guidelines.mapGetters(['Guidelines']),
      ...admin.mapGetters(['roleList']),
      ...authenticate.mapGetters(['isTenantAdmin', 'isSystemAdmin']),
      ...app.mapGetters(['loadingHasFinish']),
      currentGuideline() {
        return this.Guidelines.find(x => x.GuidelineName == this.name)
      },
      isTenantEditable() {
        return this.currentGuideline && this.currentGuideline.TenantGuidelines.length < 2
      },
    },
    watch: {
      loadingHasFinish() {
        this.fetchData()
      },
    },
    methods: {
      fetchData() {
        if (!this.loadingHasFinish) {
          return
        }
        var isGuidelineExist = this.Guidelines.find(
          x => x.GuidelineName == this.currentGuidelineName
        )
        if (!isGuidelineExist) {
          if (this.currentGuidelineName == AddGuidelineActionName) {
            this.isAddpageForm = true
          } else {
            this.$router.push({
              name: '404',
              params: {
                badURL: this.$route.fullPath,
                title: 'Guideline Not Found',
              },
            })
          }
        } else {
          this.isAddpageForm = false
        }
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }
</style>